import { useQuery } from 'react-query';
import { network } from 'services/network';

const getValidationActivitiesDrillDown = (params) => {
    return network.post('api/bo/getValidationActivitiesDrillDown', params).then((response) => {
        return response.data;
    });
};
export const useQueryGetValidationActivitiesDrillDown = (params) => {
    return useQuery(['getValidationActivitiesDrillDown', params], () => getValidationActivitiesDrillDown(params), {
        enabled: Boolean(params.componentId),
    });
};
